module.exports = __webpack_public_path__ + "img/card_section.8f385772.png";